
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  AccessibilityHelp,
  Alignment,
  AutoLink,
  Bold,
  Code,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  HorizontalLine,
  HtmlComment,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  Paragraph,
  RemoveFormat,
  SelectAll,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  Strikethrough,
  Subscript,
  Superscript,
  Underline,
  Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import MuiBox from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';

const Box = styled(MuiBox)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: theme.spacing(1),
  borderColor: theme.palette.grey[300],
  borderWidth: 1,
  overflow: 'hidden',
  '&.Mui-readOnly': {
    cursor: 'default',
  },
  '.ck.ck-editor__top .ck.ck-sticky-panel__content': {
    border: 'unset',
  },
  '.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused)': {
    boxShadow: theme.insets[2],
    border: 'unset',
  },
  '.ck-content p, .ck-content ul, .ck-content ol': {
    marginBottom: '16px',
  },
}));

function HtmlInput({ disabled, error, helper, id, label, value, onChange, readOnly }) {
  return (
    <FormControl
      variant='filled'
      error={error}
      fullWidth
    >
      <InputLabel shrink>{label}</InputLabel>
      <Box sx={{
        width: '100%',
        pt: label ? 2 : 0,
      }}>
        <CKEditor
          id={id}
          editor={ClassicEditor}
          config={{
            toolbar: {
              items: [
                'undo',
                'redo',
                // '|',
                // 'showBlocks',
                'selectAll',
                '|',
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'subscript',
                'superscript',
                'code',
                'removeFormat',
                '|',
                'bulletedList',
                'numberedList',
                'indent',
                'outdent',
                '|',
                'FontBackgroundColor',
                'FontColor',
                'FontFamily',
                'FontSize',
                'specialCharacters',
                'horizontalLine',
                'link',
                '|',
                'alignment',
                '|',
                'accessibilityHelp'
              ],
              shouldNotGroupWhenFull: true
            },
            plugins: [
              AccessibilityHelp,
              Alignment,
              AutoLink,
              Bold,
              Code,
              Essentials,
              FontBackgroundColor,
              FontColor,
              FontFamily,
              FontSize,
              GeneralHtmlSupport,
              HorizontalLine,
              HtmlComment,
              Indent,
              IndentBlock,
              Italic,
              Link,
              List,
              Paragraph,
              RemoveFormat,
              SelectAll,
              // ShowBlocks,
              SpecialCharacters,
              SpecialCharactersArrows,
              SpecialCharactersCurrency,
              SpecialCharactersEssentials,
              SpecialCharactersLatin,
              SpecialCharactersMathematical,
              SpecialCharactersText,
              Strikethrough,
              Subscript,
              Superscript,
              Underline,
              Undo
            ],
          }}
          data={value}
          disabled={readOnly || disabled}
          onChange={(event, editor) => {
            onChange && onChange(editor.getData());
          }}
        />
      </Box>
      <FormHelperText>{helper}</FormHelperText>
    </FormControl>
  );
}

export default HtmlInput;
